import { render, staticRenderFns } from "./MultistepSummaryComments.vue?vue&type=template&id=59422271"
import script from "./MultistepSummaryComments.vue?vue&type=script&lang=js"
export * from "./MultistepSummaryComments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports